export function getContrastTextColor(hex: string): string {
    const cleanedHex = hex.replace(/^#/, '');

    // Convert hex to RGB
    const r = parseInt(cleanedHex.substring(0, 2), 16);
    const g = parseInt(cleanedHex.substring(2, 4), 16);
    const b = parseInt(cleanedHex.substring(4, 6), 16);

    const [R, G, B] = [r, g, b].map((c) => {
        const channel = c / 255;
        return channel <= 0.03928
            ? channel / 12.92
            : Math.pow((channel + 0.055) / 1.055, 2.4);
    });

    const luminance = 0.2126 * R + 0.7152 * G + 0.0722 * B;

    // Use white if the luminance is low, black if high
    return luminance > 0.179 ? '#000000' : '#FFFFFF';
}